import HilbiAlert from './hilbi-alert';

export default HilbiAlert;
